import swr from 'swr';
import { API_URL } from '../API/config';
import { normalizeResourceData } from '../utils/normalize-resource-data';
const useResources = () => {
  const { data: resourceData } = swr('/api/resources', async () => {
    const res = await fetch(API_URL + '/resources?grouped=true');
    if (!res.ok) throw new Error('Resources are unavailable');
    const data = await res.json();
    return normalizeResourceData(data);
  });

  const requestLinkToEmail = async (email: string, id: string) => {
    const res = await fetch(API_URL + '/resources/request-link', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, id }),
    });
    if (!res.ok) throw new Error('Resource link is unavailable');
    const data = await res.json();
    return data;
  };

  return { resourceData, requestLinkToEmail };
};

export default useResources;
